import React from 'react'

import './LocationPin.scss'

const LocationPin = ({
  // $hover, // Magic prop: GoogleMapReact passes $hover props to hovered components using an internal mechanism
  isShowingInfoBox,
  isFocused,

  onMouseEnter,
  onMouseLeave,

  number,
  name,
  address,
  hoverBoxID = '',
}) => {
  let additionalClasses = ''
  if (isShowingInfoBox) additionalClasses += ' show-infobox'
  if (isFocused) additionalClasses += ' focused'

  return (
    <div
      className={`LocationPin ${additionalClasses}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="switch"
      aria-checked="true"
      tabIndex={0}
    >
      <div className="pin-icon" />
      <p className="pin-number">{number}</p>
      <div className="pin-hover-box" id={hoverBoxID}>
        <h4>{name}</h4>
        <p>{address}</p>
      </div>
    </div>
  )
}

export default LocationPin
